import React from 'react'


const EligigilityDetails = ({eligibility}) => {
  return (
    <div className="my-12">
    <h3 className=" uppercase letter-spacing font-w-600 text-gray-800 mt-5">
      Eligiblity Details{" "}
    </h3>
    <hr />
    <div className="mt-6 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-4">
      <div className="sm:col-span-1">
        <label
          htmlFor="first-name"
          className="block leading-6 text-gray-900 uppercase font-semibold"
        >
          IsAccepted
        </label>
        <div className="mt-2">
          <p className=" leading-6 text-gray-800">
            {eligibility?.isAccepted}
          </p>
        </div>
      </div>
      <div className="sm:col-span-1">
        <label
          htmlFor="first-name"
          className="block leading-6 text-gray-900 uppercase font-semibold"
        >
          Decline Reason
        </label>
        <div className="mt-2">
          <p className=" leading-6 text-gray-800">
            {eligibility?.declineReason}
          </p>
        </div>
      </div>
     
      <div className="sm:col-span-1">
        <label
          htmlFor="first-name"
          className="block leading-6 text-gray-900 uppercase font-semibold"
        >
          Status
        </label>
        <div className="mt-2">
          <p className=" leading-6 text-gray-800">
            {eligibility?.status}
          </p>
        </div>
      </div>
      <div className="sm:col-span-1">
        <label
          htmlFor="first-name"
          className="block leading-6 text-gray-900 uppercase font-semibold"
        >
          Primary Credit Report
        </label>
        <div className="mt-2">
          {eligibility?.primaryCreditReportUrl != null ? (
            <a
              href={eligibility?.primaryCreditReportUrl}
              target="_blank"
              className="font-medium underline"
              rel="noreferrer"
            >
              {" "}
              Click to view
            </a>
          ) : (
            ""
          )}
        </div>
      </div>
      <div className="sm:col-span-1">
        <label
          htmlFor="first-name"
          className="block leading-6 text-gray-900 uppercase font-semibold"
        >
          Is Primary Report Clean?
        </label>
        <div className="mt-2">
          <p className=" leading-6 text-gray-800">
            {eligibility?.primaryCreditReportIsClean}
          </p>
        </div>
      </div>
      <div className="sm:col-span-1">
        <label
          htmlFor="first-name"
          className="block leading-6 text-gray-900 uppercase font-semibold"
        >
          Secondary Credit Report
        </label>
        <div className="mt-2">
          {eligibility?.secondaryCreditReportUrl != null ? (
            <a
              href={eligibility?.secondaryCreditReportUrl}
              target="_blank"
              className="font-medium underline"
              rel="noreferrer"
            >
              {" "}
              Click to view
            </a>
          ) : (
            ""
          )}
        </div>
      </div>
      <div className="sm:col-span-1">
        <label
          htmlFor="first-name"
          className="block leading-6 text-gray-900 uppercase font-semibold"
        >
          Is Secondary Report Clean?
        </label>
        <div className="mt-2">
          <p className=" leading-6 text-gray-800">
            {eligibility?.secondaryCreditReportIsClean}
          </p>
        </div>
      </div>
      {/* <div className="sm:col-span-1">
                            <label htmlFor="first-name" className="block leading-6 text-gray-900 uppercase font-semibold">Tertiary Credit Report</label>
                            <div className="mt-2">
                                {eligibility?.tretiaryCreditReport != null ? <a href={eligibility?.tretiaryCreditReport} target="_blank" className="font-medium underline" rel="noreferrer" > Click to
                                    view</a> : ""}
                            </div>
                        </div> */}
      {/* <div className="sm:col-span-1">
                            <label htmlFor="first-name" className="block leading-6 text-gray-900 uppercase font-semibold">Substitute Credit Report</label>
                            <div className="mt-2">
                                {eligibility?.substituteCreditReport != null ? <a href={eligibility?.substituteCreditReport} target="_blank" className="font-medium underline" rel="noreferrer" > Click to
                                    view</a> : ""}
                            </div>
      </div> */}
      <div className="sm:col-span-1">
        <label
          htmlFor="first-name"
          className="block leading-6 text-gray-900 uppercase font-semibold"
        >
          Statement
        </label>
        <div className="mt-2">
          {eligibility?.statementUrl != null ? (
            <a
              href={eligibility?.statementUrl}
              target="_blank"
              className="font-medium underline"
              rel="noreferrer"
            >
              {" "}
              Click to view
            </a>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  </div>
  )
}

export default EligigilityDetails
